import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'Constants';

// State
import { ApiStore } from 'Store';
import { Footnote, TableHead } from 'Components/core';

function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const Table = styled.table`
  border-collapse: collapse;
  tr > * {
    padding: 8px;

    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      background-color: ${props => props.color1};
    }

    th:nth-child(3n + 2) {
      background-color: ${props => props.color2};
    }

    th:nth-child(3n + 3) {
      background-color: ${props => props.color3};
    }
    th:nth-child(3n + 4) {
      background-color: ${props => props.color4};
    }
  }

  .row:nth-child(even) {
    background-color: #e2f2f2;
  }

  tr {
    > td:nth-child(1) {
      background-color: ${props => hexToRgb(props.color1, 0.2)};
    }

    > td:nth-child(3n + 2) {
      background-color: ${props => hexToRgb(props.color2, 0.2)};
    }

    > td:nth-child(3n + 3) {
      background-color: ${props => hexToRgb(props.color3, 0.2)};
    }

    > td:nth-child(3n + 4) {
      background-color: ${props => hexToRgb(props.color4, 0.2)};
    }
  }
`;

export default () => {
  // TODO: Switch to Case when RRD sends consistently cased data
  const decodeHeader = header => {
    const map = {
      deductible: (
        <span>
          <b>Deductible</b>
        </span>
      ),
      preventive: (
        <span>
          <b>Preventive care</b>
          <br />
          (oral exams, teeth cleanings)
        </span>
      ),
      maximum: (
        <span>
          <b>Annual maximum</b>
        </span>
      ),
      basicCare: (
        <span>
          <b>Basic care</b>
          <br />
          (fillings)
        </span>
      ),
      majorCare: (
        <span>
          <b>Major care</b>
          <br />
          (crowns)
        </span>
      ),
      orthodontics: (
        <span>
          <b>Orthodontics</b>
          <br />
          (braces)
        </span>
      )
    };
    return map[header];
  };

  const rowIndexs = [
    'deductible',
    'preventive',
    'maximum',
    'basicCare',
    'majorCare',
    'orthodontics'
  ];

  const plans = ApiStore.get().dental?.dentalPlansChart?.planDentalChart;
  const state=ApiStore.get();
  if (plans) {
    const headers = ['', ...plans.map(a => a.name)];

    return (
      <div
        style={{
          overflowX: 'auto',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
        <TableHead>Compare the plans</TableHead>
        <div style={{textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
          <Table
            border
            color1="#ffffff"
            color2="#EEEEEE"
            color3="#EEEEEE"
            color4="#EEEEEE"
          >
            <tbody>
              {[
                <tr key="headers">
                  {headers.map((name, i) => (
                    <TH key={i}>{name}</TH>
                  ))}
                </tr>
              ]}
              {rowIndexs.map((rowName, rowIndex) => {
                return (
                  <TR key={rowName} odd={rowIndex % 2}>
                    <SubHeader style={{ border: '14px solid #ffffff' }}>
                      {decodeHeader(rowName)}
                    </SubHeader>
                    {plans.map((aplan, index) => {
                      return (
                        <td style={{ border: '14px solid #ffffff' ,textAlign:'left' }}>
                          {aplan[rowName]}
                        </td>
                      );
                    })}
                  </TR>
                );
              })}
            </tbody>
          </Table>

          <Footnote dangerouslySetInnerHTML={{__html:state.dental.chartFootNote}}></Footnote>
       
        </div>
        
      </div>
    );
  }
  return null;
};

const TH = styled.th`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  border: 14px solid #ffffff;
  color: #000000;
`;

const SubHeader = styled.td`
  text-align: left !important;
  height: 45px;
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #131331;
`;

const TR = styled.tr`
  background-color: ${props => (props.odd ? '#eeeeee' : '#F5F5F5')};
`;
